import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  AFFILIATES_REQUEST_HISTORY_LIST_ROUTE_NAME,
  AFFILIATES_REQUEST_HISTORY_PERMISSIONS,
  AFFILIATES_REQUEST_HISTORY_PROFILE_ROUTE_NAME,
  AFFILIATES_REQUEST_HISTORY_REAPPROVE_ROUTE_NAME,
  AFFILIATES_REQUEST_HISTORY_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_REQUEST_HISTORY,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliatesRequestHistoryModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: AFFILIATES_REQUEST_HISTORY_ROUTE_NAME,
      path: 'request-history',
      permission: AFFILIATES_REQUEST_HISTORY_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AffiliatesRequestHistoryListPage',
    });

    router.addChildRoute(AFFILIATES_REQUEST_HISTORY_ROUTE_NAME, {
      name: AFFILIATES_REQUEST_HISTORY_LIST_ROUTE_NAME,
      path: '',
      permission: AFFILIATES_REQUEST_HISTORY_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliatesRequestHistoryListPage/AffiliatesRequestHistoryListPage.vue'),
    });

    router.addChildRoute(AFFILIATES_REQUEST_HISTORY_ROUTE_NAME, {
      name: AFFILIATES_REQUEST_HISTORY_PROFILE_ROUTE_NAME,
      path: 'profile/:id/:tab',
      permission: AFFILIATES_REQUEST_HISTORY_PERMISSIONS.SHOW,
      component: () => import('@modules/affiliates-profile/pages/AffiliatesProfilePage/AffiliatesProfilePage.vue'),
    });

    router.addChildRoute(AFFILIATES_REQUEST_HISTORY_ROUTE_NAME, {
      name: AFFILIATES_REQUEST_HISTORY_REAPPROVE_ROUTE_NAME,
      path: 'reapprove/:id',
      permission: AFFILIATES_REQUEST_HISTORY_PERMISSIONS.CHANGE_STATUS,
      component: () => import('@modules/affiliates-pending/pages/AffiliatesPendingApprovePage/AffiliatesPendingApprovePage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PARTNERS_REQUESTS_HISTORY'),
      to: {
        name: AFFILIATES_REQUEST_HISTORY_LIST_ROUTE_NAME,
      },
      permission: AFFILIATES_REQUEST_HISTORY_PERMISSIONS.SHOW,
      id: AFFILIATES_REQUEST_HISTORY_LIST_ROUTE_NAME,
      order: 40,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_REQUEST_HISTORY, getTranslationKeys);
  }
}
